module.exports = __webpack_public_path__ + "img/video_img01.a4b71e5e.jpg";